var allgrade = "https://test.rujiaowang.net/api/resource/allgrade" // 年纪列表
var get_grade_list = "https://api.rujiaowang.net/api/all/get_grade_list" // 新年纪列表
var getsubject = "https://test.rujiaowang.net/api/resource/getsubject" // 科目列表
var get_subject_list = "https://api.rujiaowang.net/api/all/get_grade_subject" // 新科目列表
var getbooklist = "https://api.rujiaowang.net/api/all/get_press_list" //版本列表
var course = "https://api.rujiaowang.net/live/index/course_list" // 双师课堂
var get_course_list = "https://api.rujiaowang.net/api/course/get_course_list1" // 同步课程，知识点课程，专题课程
var get_course_info = "https://api.rujiaowang.net/api/newcourse/get_course_info" //获取课程详细信息
var xuetang = "https://api.rujiaowang.net/api/all/getxuetang_one_type" //头条新闻
var getmyterm = "https://api.rujiaowang.net/api/user/getmyterm" //我的团队
var earnings = "https://api.rujiaowang.net/live/user/mygains" //我的收益
var gainsinfo = "https://api.rujiaowang.net/live/user/gainsinfo" //我的收益---订单详情
var getcode = "https://api.rujiaowang.net/live/wechat/getcode" //登录
var wxlogin = "https://api.rujiaowang.net/live/wechat/wxlogin" //微信登录--获取个人信息
var unifiedorder = "https://api.rujiaowang.net/live/wechat/unifiedorder" //微信登录--获取data
var update_avatar = "https://api.rujiaowang.net/api/user/update_avatar" //修改头像
var get_user_vcode = "https://api.rujiaowang.net/index.php/api/all/get_user_vcode" //手机绑定验证码
var bindmobile = "https://api.rujiaowang.net/api/user/bindmobile" //确认绑定
var mianlogin = "http://api.rujiaowang.net/api/all/soulaoshi" //确认绑定
var gettime = "https://api.rujiaowang.net/api/all/gettime" //获取时间戳
var getclasslist = "https://api.rujiaowang.net/api/teacher/get_master_class_list" //获取老师所教的班级
var feedback = "http://api.rujiaowang.net/api/all/feedback" //投诉举报
var getapp_class = "http://test.rujiaowang.net/api/Appteacher/app_class" //班级列表
var get_class_app = "http://test.rujiaowang.net/api/Appteacher/class_app_up" //班级应用列表
var get_app_control = "http://test.rujiaowang.net/api/Appteacher/class_app_control" //应用管控
var class_recover_app = "http://test.rujiaowang.net/api/Appteacher/class_recover_app" //应用管控

module.exports = {
    class_recover_app,
    get_app_control,
    get_class_app,
    getapp_class,
    allgrade,
    get_grade_list,
    getsubject,
    get_subject_list,
    getbooklist,
    course,
    xuetang,
    get_course_list,
    get_course_info,
    getmyterm,
    earnings,
    gainsinfo,
    getcode,
    wxlogin,
    unifiedorder,
    update_avatar,
    get_user_vcode,
    bindmobile,
    mianlogin,
    gettime,
    getclasslist,
    feedback
}


// WEBPACK FOOTER //
// ./src/api/index.js